import { createSlice } from "@reduxjs/toolkit";

export const getInitialTheme = () => {
  try {
    const storedTheme = localStorage.getItem("theme");
    if (storedTheme) {
      return storedTheme;
    }
  } catch (error) {
    console.warn("localStorage not available:", error);
  }

  // Check system preference
  if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
    return "dark";
  }
  // Default to light mode
  return "light";
};

const initialState = {
  theme: getInitialTheme(),
};

const themeSlice = createSlice({
  name: "themeData",
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.theme = state.theme === "light" ? "dark" : "light";
      try {
        localStorage.setItem("theme", state.theme);
      } catch (error) {
        console.warn("Failed to save theme to localStorage:", error);
      }
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
      try {
        localStorage.setItem("theme", action.payload);
      } catch (error) {
        console.warn("Failed to save theme to localStorage:", error);
      }
    },
  },
});

export const { toggleTheme, setTheme } = themeSlice.actions;
export default themeSlice.reducer;

